import { jsx as _jsx } from "react/jsx-runtime";
import TalentReview from "../../components/TalentReview/TalentReview";
var TalentReviewPage = function () {
    return _jsx(TalentReview, {});
};
export default TalentReviewPage;
